import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VTextField,{attrs:{"value":_vm.hoursTimeFormatted,"label":_vm.label,"disabled":_vm.disabled,"placeholder":_vm.placeholder,"rules":[_vm.rules.hoursGreaterThanZero, _vm.rules.hoursValidTime],"readonly":_vm.readonly},on:{"change":function($event){_vm.hoursTimeFormatted = $event}}})}
var staticRenderFns = []

export { render, staticRenderFns }